import { userSelector } from 'gs-user-selector';

export default {
  props: {
    // 流程实例ID
    actInstId: {
      type: String
    },
    showBack: {
      type: Boolean,
      default: false
    },
    operType: {
      type: String,
      default: '0' //新增 0  编辑 1
    },
    formId: {
      type: String,
      default: '' //1858415537667837952
    },
    defaultUsers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 中间节点审批不同意，直接终止流程
    isTerminateTask: {
      type: Boolean,
      default: false
    },
    // 审批用户ID（身份证号）
    assigneeUserId: String,
    // 审批用户姓名
    assigneeUserName: String,
    // 审批用户机构代码
    assigneeOrgId: String,
    // 审批用户机构名称
    assigneeOrgName: String,
    // 消息标题
    msgTit: {
      type: String,
      default: ''
    },
    // 消息地址
    msgUrl: {
      type: String,
      default: ''
    },
    businessId: {
      type: String,
      default: ''
    },
    // 来源应用
    module: {
      type: String,
      default: ''
    },
    variables: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 来源消息平台
    platform: {
      type: String,
      default: 'pc'
    },
    // 流程审核完成后事件
    auditComplete: {
      type: Function,
      default: null
    },
    error: {
      type: Function,
      default: null
    },
    // 流程审核前事件
    beforeAudit: {
      type: Function,
      default: null
    },
    customSlotName: {
      type: String,
      default: ''
    },
    tit: {
      type: String,
      default: '审批'
    },
    beforeOpen: { //打开审批组件前置事件
      type: Function,
      default: null
    },
    // 自定义卡槽内容是否绑定点击事件
    bindEvent: {
      type: Boolean,
      default: true
    },
    showCustomSlot: {
      type: Boolean,
      default: false
    },
    /*  showFileUpload: {
         type: Boolean,
         default: false
     }, */
    showcc: {
      type: Boolean,
      default: false
    },
    confirmBtnText: {
      type: String,
      default: "提  交"
    },
    cancelBtnText: {
      type: String,
      default: "取  消"
    },
    modalWidth: {
      type: String,
      default: "800"
    },
    modalHeight: {
      type: String,
      default: "500"
    },
    extraOrgId: {
      type: String,
      default: ''
    },
    extraRegId: {
      type: String,
      default: ''
    },
    selectUsers: {
      type: String,
      default: ''
    },
    extraCityId: {
      type: String,
      default: ''
    }
  },
  components: {
    userSelector: userSelector
  },
  data: function data() {
    return {
      formArr: [],
      formDataVarObj: {},
      ProcessVarObj: {},
      indeterminate: false,
      checkAll: true,
      bootData: {},
      custom_loading: false,
      hasApproveAuth: false,
      activeTab: "track",
      currentNodeName: "",
      currentNodeId: "",
      isLastUserTask: false,
      showApproveUser: true,
      showTc: true,
      formValidate: {
        taskId: "",
        isApprove: "1",
        isApproveStr: "同意上报",
        approvalContent: "同意上报",
        approvalDate: this.dateFormat(new Date()),
        csldbh: "",
        candidateUsers: [],
        isBack: false,
        isDelegateTask: false,
        delegateUserId: "",
        delegateUserName: ""
      },
      currTask: {},
      component: null,
      showSelectModal: false,
      formLabel: {
        approvalContent: "审核意见",
        approvalDate: "审核时间",
        approvalNode: "审核节点",
        approvalOrg: "审核部门",
        approvalUser: "审核人"
      },
      ruleValidate: {
        isApprove: [{
          required: true,
          message: "审核结果不能为空",
          trigger: "blur,change"
        }],
        approvalContent: [{
          required: true,
          message: "审核意见不能为空",
          trigger: "blur,change"
        }],
        approvalDate: [{
          required: true,
          message: "审核时间不能为空",
          trigger: "blur,change",
          pattern: /.+/
        }],
        delegateUserName: [{
          required: true,
          message: "委派人不能为空",
          trigger: "blur,change"
        }],
        approveCheckedUser: [{
          required: true,
          message: "审批人不能为空",
          trigger: "blur,change"
        }],
        backNodeId: [{
          required: true,
          message: "退回节点不能为空",
          trigger: "blur,change"
        }]
      },
      orgArr: [],
      selectOrgArr: [],
      orgUserList: [],
      checkedUser: [],
      trackArr: [],
      curNodeBtnMarkArr: [],
      delegationState: "",
      delegationName: "",
      disabledSubmit: false,
      // 审批意见型按钮数组
      optionsBtnArr: [],
      // 自定义类型按钮
      customBtnArr: [],
      isApprove: '1',
      rollbackNodeList: [],
      csldList: [], // 抄送领导
      isOpen: false,
      uploadList: [],
      reference: null,
      selectNode: '',
      nextNodeList: [],
      //所选择的节点是否需要法制审核
      selectNodeSffzsh: false,
      //当前节点是否是法制审核节点
      curNodeSffzsh: false,
      //当前同意按钮名称
      curAgreeButtonName: '',
      //委派人员
      delegateUser: {}
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/general-approve/mixins/data.js
// module id = 11
// module chunks = 0